import { CommonModule } from '@angular/common';
import {
  AfterContentInit,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  NgModule,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
} from '@angular/core';
import { SystemSortableColumnModule, TemplateDirective } from './directives';
import { SystemPaginatorModule } from '../../molecules/paginator/paginator.component';
import { LoadingSpinnerModule } from '@app/shared/loading-spinner/loading-spinner.module';
import { Flowbite } from '@app/core/utils/flowbite';
import { SystemSortIconModule } from './components';
import { SystemTableService } from './services';

export interface TableEvent {
  first?: number | undefined | null;
  rows?: number | undefined | null;
  sortField?: string | string[] | null | undefined;
  sortOrder?: number | undefined | null;
}

@Component({
  selector: 'app-system-table',
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
@Flowbite()
export class TableComponent implements AfterContentInit, OnInit {
  @Input() value: any[] = [];
  @Input() isLoading = false;
  @Input() paginator = false;
  @Input() rows = 10;
  @Input() totalItems = 0;
  @Output() pageUpdated: EventEmitter<any> = new EventEmitter();
  @ContentChildren(TemplateDirective) templates!: QueryList<TemplateDirective>;
  currentPage = 0;
  sortOrder = -1;
  sortField: string | undefined | null;
  headerTemplate!: TemplateRef<any>;
  bodyTemplate!: TemplateRef<any>;
  emptyMessageTemplate!: TemplateRef<any>;
  private defaultSortOrder = 1;

  constructor(private tableService: SystemTableService) {}

  ngOnInit(): void {
    this.onPageChanged(this.currentPage);
  }

  ngAfterContentInit() {
    this.templates.forEach(template => {
      switch (template.name) {
        case 'header':
          this.headerTemplate = template.template;
          break;
        case 'body':
          this.bodyTemplate = template.template;
          break;
        case 'emptymessage':
          this.emptyMessageTemplate = template.template;
          break;
      }
    });
  }

  onPageChanged($event: number) {
    this.currentPage = $event;

    this.pageUpdated.emit({
      first: this.rows * this.currentPage,
      rows: this.rows,
      sortOrder: this.sortOrder,
      sortField: this.sortField,
    });
  }

  isSorted(field: string) {
    return this.sortField && this.sortField === field;
  }

  sort(event: any) {
    this.sortOrder = this.sortField === event.field ? this.sortOrder * -1 : this.defaultSortOrder;
    this.sortField = event.field;
    this.sortSingle();
  }

  sortSingle() {
    this.onPageChanged(this.currentPage);
    this.tableService.onSort({
      field: <string>this.sortField,
      order: this.sortOrder,
    });
  }

  trackByItem(_index: number, item: any) {
    return item._id;
  }
}

@NgModule({
  declarations: [TableComponent],
  exports: [TableComponent, TemplateDirective, SystemSortableColumnModule, SystemSortIconModule],
  imports: [CommonModule, TemplateDirective, SystemPaginatorModule, LoadingSpinnerModule],
})
export class SystemTableModule {}
